import { isNull } from 'lodash';
import { MathNumericType } from 'mathjs';
import { ICell } from 'models/interfaces/spreadsheet-types/core-types';
import { getNumberValue } from 'utilities/getNumberValue';
import { CellValueArray, NormalizeMathArray } from './types';

const CELL_CONSTRUCTOR_NAME = 'Cell';

const normalizeMathArray: NormalizeMathArray = mathArray =>
  (mathArray as CellValueArray).map(item => {
    // Some cells (e.g. GRID_NUMBER_CHECKBOX) return the full cell object instead of the value
    // This normalizes the array by extracting and parsing the numeric value
    if (!isNull(item) && typeof item === 'object' && item?.constructor?.name === CELL_CONSTRUCTOR_NAME) {
      return getNumberValue((item as ICell)?.value as number);
    }

    return item as MathNumericType;
  });

export default normalizeMathArray;
